<script>
import RegisterForm from "../components/auth/register_form.vue";
import { mapGetters } from "vuex";

export default {
  name: "RegisterView",
  components: {
    RegisterForm,
  },

  computed: {
    ...mapGetters("config", ["features"]),
  },
};
</script>

<template>
  <eg-b-container>
    <eg-b-row>
      <eg-b-col>
        <register-form />
      </eg-b-col>
    </eg-b-row>
  </eg-b-container>
</template>
